import { render, staticRenderFns } from "./CloudVertical.vue?vue&type=template&id=54aa4081&"
import script from "./CloudVertical.vue?vue&type=script&lang=js&"
export * from "./CloudVertical.vue?vue&type=script&lang=js&"
import style0 from "./CloudVertical.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports